export default "__VITE_ASSET__BNmth$4n__"